module.exports = __webpack_public_path__ + "static/media/down.aa98fe62.svg";